import React from 'react';
import { Link } from 'react-router-dom';
import { siteConfig } from '../../data/mock';

// Short factual summary of the business (mirrors the LocalBusiness JSON-LD).
export const BusinessFacts = () => {
  const { contact } = siteConfig;
  const facts = [
    ['Qui ?', "Le Rosebif, jardinier à domicile pour les particuliers, basé en Vendée."],
    ['Où ?', "Basé à Coëx (85220), j'interviens dans un rayon d'environ 25 à 30 km : Brétignolles-sur-Mer, Saint-Gilles-Croix-de-Vie, Givrand, Apremont, Aizenay et les communes voisines."],
    ['Quoi ?', "Tonte, taille de haies (jusqu'à 3 m), débroussaillage, désherbage manuel, rénovation de pelouse existante, vigilance de résidence secondaire et petit bricolage de 2 h maximum."],
    ['Ce que je ne fais pas', "Pas de paysagisme ni de création de jardin, pas d'élagage à risque, pas de plomberie, d'électricité ni de gros travaux."],
    ['Combien ?', "Tonte 0,28 €/m² TTC, haies dès 5 €/ml TTC, débroussaillage 0,75 €/m² TTC, rénovation de pelouse dès 1,50 €/m² TTC. Devis gratuit."],
    ["Crédit d'impôt", `Service à la Personne déclaré (${contact.sapAgreement}) : 50 % de crédit d'impôt sur la main-d'œuvre pour les particuliers éligibles. Attestation fiscale annuelle fournie.`],
    ['Quand ?', 'Lundi, mardi, jeudi et vendredi, de 11 h à 17 h.'],
    ['SIRET', contact.siret],
  ];
  return (
    <section className="py-12 bg-white" id="en-bref" data-testid="business-facts-section">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-6">Le Rosebif en bref</h2>
          <dl className="divide-y divide-gray-100 border border-gray-200 rounded-xl bg-gray-50/60">
            {facts.map(([term, value], i) => (
              <div key={term} className="grid sm:grid-cols-[170px_1fr] gap-1 sm:gap-4 px-5 py-3.5" data-testid={`business-fact-${i}`}>
                <dt className="text-sm font-semibold text-emerald-800">{term}</dt>
                <dd className="text-sm text-gray-700">{value}</dd>
              </div>
            ))}
          </dl>
          <p className="text-sm text-gray-600 mt-4">
            Pour un devis : <Link to="/devis" className="text-emerald-700 font-semibold underline" data-testid="business-facts-devis-link">formulaire de devis</Link> ou <a href={`tel:+33${contact.phone.replace(/\s/g, '').slice(1)}`} className="text-emerald-700 font-semibold underline" data-testid="business-facts-phone-link">{contact.phone}</a>.
          </p>
        </div>
      </div>
    </section>
  );
};

export default BusinessFacts;
